import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <details>
  <summary>Grouping products in one project (recommended)</summary>
      <p>{`  If you have multiple customer-facing products (e.g. a marketing website + mobile app + web app), it's best to install PostHog on them all and `}<a parentName="p" {...{
          "href": "/docs/settings/projects"
        }}>{`group them in one project`}</a>{`. `}</p>
      <p>{`  This makes it possible to track users across their entire journey (e.g. from visiting your marketing website to signing up for your product), or how they use your product across multiple platforms.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      